import { NavLink, Outlet, Link } from 'react-router-dom';
import { admin } from '../../lib/api';
import { useApi } from '../../hooks/useApi';
import { useAdminT } from './adminI18n';

export default function AdminLayout() {
  const t = useAdminT();
  const reviewQ = useApi(() => admin.reviewQueue(undefined, 100), []);
  const proposalQ = useApi(() => admin.proposalQueue(undefined, 100), []);
  const reviewCount = reviewQ.status === 'success' ? reviewQ.data.length : undefined;
  const proposalCount = proposalQ.status === 'success' ? proposalQ.data.length : undefined;

  const link = (isActive: boolean) => `admin-nav__link${isActive ? ' is-active' : ''}`;
  const badge = (n?: number) =>
    n != null && n > 0 ? <span className="admin-nav__badge">{n}</span> : null;

  return (
    <div className="admin-shell">
      <header className="admin-topbar">
        <div className="admin-topbar__brand">
          <span className="admin-topbar__mark">BookQuest</span>
          <span className="admin-topbar__tag">Admin</span>
        </div>
        <Link to="/library" className="admin-topbar__back">← {t('backToApp')}</Link>
      </header>

      <div className="admin-body">
        <nav className="admin-nav" aria-label={t('console')}>
          <NavLink to="/admin" end className={({ isActive }) => link(isActive)}>
            {t('nav.overview')}
          </NavLink>

          <div className="admin-nav__group">{t('nav.content')}</div>
          <NavLink to="/admin/review" className={({ isActive }) => link(isActive)}>
            {t('nav.review')} {badge(reviewCount)}
          </NavLink>
          <NavLink to="/admin/proposals" className={({ isActive }) => link(isActive)}>
            {t('nav.proposals')} {badge(proposalCount)}
          </NavLink>
          <NavLink to="/admin/curation" className={({ isActive }) => link(isActive)}>
            {t('nav.curation')}
          </NavLink>
          <NavLink to="/admin/reports" className={({ isActive }) => link(isActive)}>
            {t('nav.reports')}
          </NavLink>

          <div className="admin-nav__group">{t('nav.ops')}</div>
          <NavLink to="/admin/jobs" className={({ isActive }) => link(isActive)}>
            {t('nav.jobs')}
          </NavLink>
          <NavLink to="/admin/cost" className={({ isActive }) => link(isActive)}>
            {t('nav.cost')}
          </NavLink>
          <NavLink to="/admin/ops-report" className={({ isActive }) => link(isActive)}>
            {t('nav.opsReport')}
          </NavLink>

          <div className="admin-nav__group">{t('nav.policy')}</div>
          <NavLink to="/admin/pricing" className={({ isActive }) => link(isActive)}>
            {t('nav.pricing')}
          </NavLink>

          <div className="admin-nav__group">{t('nav.people')}</div>
          <NavLink to="/admin/credentials" className={({ isActive }) => link(isActive)}>
            {t('nav.credentials')}
          </NavLink>

          <div className="admin-nav__group">{t('nav.gov')}</div>
          <NavLink to="/admin/institutions" className={({ isActive }) => link(isActive)}>
            {t('nav.institutions')}
          </NavLink>
          <NavLink to="/admin/gamification" className={({ isActive }) => link(isActive)}>
            {t('nav.gamification')}
          </NavLink>
          <NavLink to="/admin/cert-profiles" className={({ isActive }) => link(isActive)}>
            {t('nav.certProfiles')}
          </NavLink>
          <NavLink to="/admin/standards" className={({ isActive }) => link(isActive)}>
            {t('nav.standards')}
          </NavLink>
        </nav>

        <main className="admin-main" id="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
